import followsEnabled from "@follows/follows-enabled";
import { MembershipConfig } from "@voxmedia/duet-context/context/config-context";

export const MEMBERSHIP_CONFIG: MembershipConfig = {
  productName: "Subscription",
  ctaLabel: "Subscribe to The Verge",
  ctaUrl: "/subscribe",
  entitlementBadges: { theverge_subscription: "subscriber" },
  badgeSectionLabel: "Subscriber badge",
  badgeToggleLabel: "Show “subscriber” badge in comments",
  productUrl: "/account/subscription",
  sentenceProduct: "subscription to The Verge",
  navNewsletters: "Newsletters",
  navProductName: "Subscription & Billing",
  navPodcasts: "Podcasts",
  navFeeds: "RSS Feeds",
  newslettersEmbedUrl:
    "https://link.theverge.com/manage/6xd/subscriber-preferences-embed",
  contactEmail: "subscriptions@theverge.com",
  entitlementName: "theverge_subscription",
  showCommentingName: true,
  faqUrl: "https://theverge.zendesk.com/hc/en-us",
  giftArticleMonthlyLimit: 5,
  giftArticleLinkDaysValid: 5,
  feedsDek:
    "Full-text feeds of everything on The Verge — exclusively for subscribers.",
  feeds: [
    {
      sectionLabel: "All Stories",
      links: [
        {
          url: "https://www.theverge.com/rss/partner/subscriber-only-full-feed/rss.xml",
          label: "Articles",
        },
        {
          url: "https://www.theverge.com/rss/quickposts",
          label: "Quick posts",
        },
      ],
    },
    {
      sectionLabel: "Sections",
      links: [
        {
          url: "https://www.theverge.com/rss/partner/subscriber-only-tech/rss.xml",
          label: "Tech (includes tech reviews)",
        },
        {
          url: "https://www.theverge.com/rss/partner/subscriber-only-reviews/rss.xml",
          label: "Reviews",
        },
        {
          url: "https://www.theverge.com/rss/partner/subscriber-only-science/rss.xml",
          label: "Science",
        },
        {
          url: "https://www.theverge.com/rss/partner/subscriber-only-entertainment/rss.xml",
          label: "Entertainment",
        },
        {
          url: "https://www.theverge.com/rss/partner/subscriber-only-transportation/rss.xml",
          label: "Transportation",
        },
      ],
    },
    {
      sectionLabel: "Newsletters",
      links: [
        {
          url: "https://www.theverge.com/rss/partner/subscriber-only-notepad/rss.xml",
          label: "Notepad",
        },
        {
          url: "https://www.theverge.com/rss/partner/subscriber-only-the-stepback/rss.xml",
          label: "The Stepback",
        },
        {
          url: "https://www.theverge.com/rss/partner/subscriber-only-installer/rss.xml",
          label: "Installer",
        },
        {
          url: "https://www.theverge.com/rss/partner/subscriber-only-optimizer-newsletter/rss.xml",
          label: "Optimizer",
        },
      ],
    },
  ],
  additionalMenuItems: followsEnabled
    ? [
        {
          index: 3,
          path: "/account/following",
          linkText: "Following",
        },
        {
          index: 4,
          path: "/account/notification-settings",
          linkText: "Notification Settings",
        },
      ]
    : [
        {
          index: 3,
          path: "/account/notification-settings",
          linkText: "Notification Settings",
        },
      ],
  corporateEntitlements: [
    {
      name: "OpenAI",
      emailDomains: ["openai.com"],
      refId: "openai-subscription-corporate-comp",

      accountPageMsg:
        "Your OpenAI corporate account is linked to Google login.",
      supportingCastPriceId:
        process.env.NEXT_PUBLIC_DEPLOY_ENV === "production" ? "64047" : "65070",
    },
  ],
  sailthruLists: [
    "Verge Paid Subscribers",
    "Command Line Active Subscribers",
    "Notepad Active Subscribers",
    "Active Subscriber Updates",
    "The Stepback Active Subscribers",
    "Optimizer Active Subscribers",
    "Installer",
  ],
  registeredUsersSailthruList: "Verge Registered Users",
  requireSignupCaptcha: true,
};
